import { createFileRoute } from '@tanstack/react-router';
import CreateGroup from '../../../features/management/groups/group/create';
import {
  createPermissionGuard,
  getPermissionSet,
  GROUP_MANAGEMENT_PERMISSIONS,
} from '@bmwe/ui';

export const Route = createFileRoute('/verwaltung/gruppen/neu')({
  component: CreateGroup,
  beforeLoad: createPermissionGuard(
    getPermissionSet(GROUP_MANAGEMENT_PERMISSIONS, 'EDIT'),
  ),
});

export const CreatGroupRoute = Route;
